var React = require('react');

function ArrowCircleUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0zm0 3C12.402 3 3 12.402 3 24c0 9.875 6.816 18.158 16 20.401V28h-4.91c-1.665 0-2.601-1.914-1.58-3.228l9.911-12.742a2 2 0 013.158 0l9.91 12.742c1.022 1.314.086 3.228-1.578 3.228H29v16.401C38.184 42.158 45 33.875 45 24c0-11.598-9.402-21-21-21z"}));
}

ArrowCircleUp.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ArrowCircleUp;

ArrowCircleUp.default = ArrowCircleUp;
